// import React, { useState, useEffect } from 'react';

import { API, Storage } from 'aws-amplify';
import { listUserProfiles } from '../graphql/queries';

export async function fetchUserProfile(user) {
  const loggedInUser = `${user.attributes?.sub}::${user.username}`;
  const username = user.username;
  const myFilter = {
    owner: { eq: loggedInUser },
  };
  const apiData = await API.graphql({
    query: listUserProfiles,
    variables: { filter: myFilter },
  });
  const userProfilesFromAPI = apiData.data.listUserProfiles.items.filter(
    (items) => items['_deleted'] !== true
  );
  // Get S3 profileImage if there is one
  await Promise.all(
    userProfilesFromAPI.map(async (profile) => {
      if (profile.profileImage) {
        const url = await Storage.get(username);
        profile.profileImage = url; // is this updating userProfile
        // console.log(`profileImage: ${profile.profileImage}`);
      }
      return profile;
    })
  );
  return userProfilesFromAPI[0];
}
